import type { DateFormat } from '@luna/date';

import type { Misc } from '../../types/Misc';

export const miscBaseFeatureConfig: Misc = {
    addTokenToDownloadPayload: false,
    apiDateTimeFormat: "yyyy-MM-dd'T'HH:mm:ssXXX" as DateFormat,
    enableMSProductConfiguration: false,
    groupingTitles: false,
    externalPlatformTargetClientId: '',
    securityEntityAcceptVersionAll: '',
    securityEntityAcceptVersionSingle: '',
};
